<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M835 1078 c-55 -67 -102 -126 -103 -130 -2 -5 40 20 93 54 105 68
118 85 113 154 l-3 43 -100 -121z"
      />
      <path
        d="M862 978 c-128 -83 -232 -152 -230 -154 2 -1 52 6 110 16 122 20 172
45 254 122 47 44 126 169 107 168 -4 -1 -113 -69 -241 -152z"
      />
      <path
        d="M516 918 c-3 -24 -8 -64 -11 -90 -4 -33 -10 -45 -19 -42 -10 4 -15
-15 -20 -72 -3 -43 -4 -79 -2 -81 2 -2 13 12 25 32 25 43 40 41 56 -6 10 -28
17 -35 43 -37 25 -3 32 1 32 14 0 32 15 3 70 -139 l55 -141 140 -34 c128 -31
144 -33 192 -22 105 23 183 114 183 212 0 41 -3 49 -16 46 -11 -2 -18 -16 -21
-41 -9 -87 -59 -149 -139 -173 -52 -15 -57 -14 -181 16 l-128 31 -44 110 c-35
90 -41 113 -30 120 8 5 19 9 26 9 12 0 35 67 47 138 5 28 3 32 -17 32 -54 0
-64 -9 -70 -63 -4 -28 -11 -55 -15 -59 -12 -12 -26 36 -23 75 2 18 -2 27 -12
27 -10 0 -28 32 -49 87 -40 102 -64 119 -72 51z m58 -125 c6 -19 3 -23 -13
-23 -22 0 -25 10 -14 49 6 25 14 18 27 -26z"
      />
      <path
        d="M422 860 l-21 -60 33 0 c32 0 33 1 39 51 4 29 4 56 1 60 -14 23 -34
4 -52 -51z"
      />
      <path
        d="M1067 843 c-2 -5 -7 -26 -11 -48 l-6 -40 35 39 c19 22 35 43 35 48 0
10 -47 11 -53 1z"
      />
      <path
        d="M974 833 c-29 -4 -31 -7 -42 -66 -7 -34 -15 -73 -19 -86 l-6 -24 44
24 c39 21 45 30 56 74 14 61 15 86 6 83 -5 0 -22 -3 -39 -5z"
      />
      <path
        d="M843 813 c-17 -3 -23 -15 -32 -69 -7 -35 -16 -75 -21 -88 -7 -19 -5
-25 8 -29 10 -2 27 -30 40 -64 12 -33 35 -72 51 -87 52 -49 137 -51 188 -4 29
26 106 185 97 199 -14 24 -35 2 -69 -76 -42 -94 -65 -115 -124 -115 -51 0 -76
22 -104 93 -23 57 -23 60 -7 110 9 29 20 71 24 95 7 45 5 46 -51 35z"
      />
      <path
        d="M349 759 c-34 -36 -37 -59 -10 -76 18 -11 21 -7 40 47 22 67 14 76
-30 29z"
      />
      <path
        d="M404 676 c-18 -56 -34 -73 -34 -36 0 27 -16 25 -24 -2 l-6 -23 -15
23 c-21 28 -41 28 -60 -1 -8 -13 -70 -54 -137 -92 -68 -38 -125 -70 -127 -72
-3 -2 2 -10 10 -18 12 -13 29 -6 129 52 100 57 191 93 189 74 0 -3 -17 -53
-37 -110 l-37 -104 -122 -46 c-93 -35 -123 -50 -123 -63 0 -10 6 -18 13 -18
17 0 250 90 262 101 6 6 26 58 46 117 34 101 38 107 61 104 26 -2 26 -1 30 80
2 46 3 85 2 86 -1 2 -10 -21 -20 -52z"
      />
      <path
        d="M492 595 c-11 -24 0 -36 13 -15 14 23 25 5 65 -107 62 -172 84 -216
130 -267 67 -72 116 -96 271 -130 21 -5 28 -2 32 14 4 15 -1 21 -16 25 -12 3
-44 9 -70 15 -74 16 -111 35 -161 80 -63 58 -77 83 -137 250 -29 80 -56 149
-60 154 -5 5 -15 4 -24 -4 -10 -8 -15 -9 -15 -1 0 20 -16 12 -28 -14z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconAedesAegypti',
}
</script>

<style></style>
